import { createContext, useContext } from 'react';
import { CLEAR_IAP_AUTH_REQUIRED, LOGOUT, readJobsSensitiveFilters, SET_2FA_DATA, SET_ACCOUNT, SET_ACCOUNT_GROUPS, SET_ACCOUNTS, SET_AUTHDATA, SET_CURRENT_CUSTOMER, SET_IAP_AUTH_REQUIRED, SET_JOBS_SENSITIVE_FILTERS, SET_MESSAGES, SET_PASSWORD_LOGIN_DATA, SET_PAYMENT_METHODS, SET_USER } from 'store/actions/actions';
const initState = () => {
    const token = localStorage.getItem('accessToken');
    const initialData = {
        accessToken: '',
        account: null,
        accountGroups: null,
        accountSettings: {},
        jobsSensitiveFilters: {},
        iapAuthDetails: null,
        iapAuthUnreadable: false,
        iapAuthRequired: false,
        invoices: null,
        messages: [],
        modalType: '',
        otpImage: '',
        otpToken: '',
        signinEmail: '',
        signinSsoBackup: false,
        paymentMethods: [],
        user: null,
        resToken: '',
        source: ''
    };
    return {
        ...initialData,
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        accessToken: token || '',
        jobsSensitiveFilters: readJobsSensitiveFilters()
    };
};
export const initialState = initState();
export function rootReducer(state, action) {
    state ??= initialState;
    switch (action.type) {
        case SET_AUTHDATA:
            return {
                ...state,
                // TODO: We re-use `AuthData` interface for API responses and internal stuff, we need to split these
                accessToken: action.payload.accessToken,
                account: action.payload.account,
                // Null makes `Account` refetch; a list kept from a prior sign-in in this
                // tab may predate the account's groups or this user's admin rights.
                accountGroups: null,
                resToken: action.payload.resToken,
                user: action.payload.user
            };
        case LOGOUT:
            return {
                ...state,
                accessToken: '',
                account: action.payload.account,
                accountGroups: null,
                iapAuthDetails: null,
                iapAuthRequired: false,
                iapAuthUnreadable: false,
                signinSsoBackup: false,
                user: action.payload.user,
                // Clear in-memory PII too; the store outlives sign-out (no reload), so
                // otherwise the next user on this machine re-seeds and re-persists it.
                jobsSensitiveFilters: {}
            };
        case SET_USER:
            return {
                ...state,
                user: action.payload.user
            };
        case SET_ACCOUNT_GROUPS:
            return {
                ...state,
                accountGroups: action.payload.accountGroups
            };
        case SET_ACCOUNTS:
            return {
                ...state,
                accounts: action.payload.accounts
            };
        case SET_ACCOUNT:
            return {
                ...state,
                account: action.payload.account
            };
        case SET_MESSAGES:
            return {
                ...state,
                messages: action.payload
            };
        case SET_2FA_DATA:
            return {
                ...state,
                otpImage: action.payload.otpImage,
                otpToken: action.payload.otpToken,
                resToken: action.payload.resToken
            };
        case SET_PASSWORD_LOGIN_DATA:
            return {
                ...state,
                signinEmail: action.payload.email,
                signinSsoBackup: action.payload.ssoBackup ?? false
            };
        case SET_CURRENT_CUSTOMER:
            return {
                ...state,
                customer: action.payload.currentCustomer
            };
        case SET_PAYMENT_METHODS:
            return {
                ...state,
                paymentMethods: action.payload.paymentMethods
            };
        case SET_JOBS_SENSITIVE_FILTERS:
            return {
                ...state,
                jobsSensitiveFilters: action.payload.jobsSensitiveFilters
            };
        case SET_IAP_AUTH_REQUIRED:
            return {
                ...state,
                iapAuthDetails: action.payload.details,
                iapAuthUnreadable: action.payload.unreadable,
                iapAuthRequired: true
            };
        case CLEAR_IAP_AUTH_REQUIRED:
            return {
                ...state,
                iapAuthDetails: null,
                iapAuthUnreadable: false,
                iapAuthRequired: false
            };
    }
}
const StoreContext = createContext({});
export const StoreProvider = StoreContext.Provider;
export const useGlobalState = () => useContext(StoreContext);
